import { render, staticRenderFns } from "./ProudctCopy.vue?vue&type=template&id=3ae86eb8&scoped=true"
import script from "./ProudctCopy.vue?vue&type=script&lang=js"
export * from "./ProudctCopy.vue?vue&type=script&lang=js"
import style0 from "./ProudctCopy.vue?vue&type=style&index=0&id=3ae86eb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae86eb8",
  null
  
)

export default component.exports